import { Card, CardContent } from "../../ui/card";
import { SummaryHeader } from "../../ui/SummaryHeader";
import MarketingLoader from "../../../components/loaders/MarketingLoader";
import { useMarketingEcomm } from "../hooks/useMarketingEcomm";
import { DataFreshness } from "../../../components/feedback/DataFreshness";
import { isIncompleteCurrentMonth } from "../../../utils/dateUtils";

type MarketingKpiCardsProps = {
  month?: string;
  limit?: number;
};

export function EcommMarketingKpi({
  month = "2025-04",
  limit = 40,
}: MarketingKpiCardsProps) {
  const { data, isLoading } = useMarketingEcomm(month, limit);

  



const totalOrders = data?.orders_calculation.total_orders ?? 0;
const ordersGrowth = data?.orders_calculation.order_growth?.toFixed(2) ?? "0";

  const totalNewCustomers = data?.percent_new_customers?.new_customers ?? 0;
  const totalCustomers = data?.percent_new_customers?.total_customers ?? 1;
  const customerAcquisitionRate = (
    (totalNewCustomers / totalCustomers) *
    100
  ).toFixed(2);

  const currentRoas = data?.roas_calculation?.current_roas ?? 0;
  const roasChange = data?.roas_calculation?.change_rate_percent?.toFixed(2) ?? "0";

  const currentCac = data?.cac_calculation?.current_cac ?? 0;
  const cacChange = data?.cac_calculation?.growth_rate_percent?.toFixed(2) ?? "0";
  const showTrend = !isIncompleteCurrentMonth(month);

  return (
    <>
      <SummaryHeader
        title="Quick Summary"
      />
      <DataFreshness monthString={month} className="mb-4" />
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {/* New Customers */}
        <Card>
          {/* <CardTitle>New Customers</CardTitle> */}
          {isLoading ? (
            <MarketingLoader variant="marketing-kpi" itemCount={1} />
          ) : (
            <CardContent>
              <div className="flex items-center justify-between pb-2">
              <p className="text-sm font-medium text-muted-foreground">
                New Customers
              </p>
              <div className="h-4 w-4 text-muted-foreground"></div>
            </div>
              <div className="text-2xl font-bold">{totalNewCustomers}</div> 
              <p className="text-sm">
                {customerAcquisitionRate}% of total customers
              </p>
            </CardContent>
          )}
        </Card>

        {/* ROAS */}
        <Card>
         
          {isLoading ? (
            <MarketingLoader variant="marketing-kpi" itemCount={1} />
          ) : (
            <CardContent>
              <div className="flex items-center justify-between pb-2">
              <p className="text-sm font-medium text-muted-foreground">
                Return on Ad Spend
              </p>
              <div className="h-4 w-4 text-muted-foreground"></div>
            </div>
              <div className="text-2xl font-bold">{currentRoas}%</div> 
              {showTrend && (
                <p
                  className={`text-sm ${
                    Number(roasChange) >= 0
                      ? "text-green-500"
                      : "text-red-600"
                  }`}
                >
                  {Number(roasChange) >= 0 ? "+" : ""}
                  {roasChange}% from last month
                </p>
              )}
            </CardContent>
          )}
        </Card>

        {/* CAC */}
        <Card>
          {isLoading ? (
            <MarketingLoader variant="marketing-kpi" itemCount={1} />
          ) : (
            <CardContent>
              <div className="flex items-center justify-between pb-2">
              <p className="text-sm font-medium text-muted-foreground">
                Customer Acquisition Cost
              </p>
              <div className="h-4 w-4 text-muted-foreground"></div>
            </div>
              <div className="text-2xl font-bold">${currentCac.toFixed(2)}</div>  
              {showTrend && (
                <p
                  className={`text-sm ${
                    Number(cacChange) >= 0
                      ? "text-green-500"
                      : "text-red-600"
                  }`}
                >
                  {Number(cacChange) > 0 ? "+" : ""}
                  {cacChange}% from last month
                </p>
              )}
            </CardContent>
          )}
        </Card>
        {/* Conversion Rate replaced with total orders */}
        <Card>
          {isLoading ? (
            <MarketingLoader variant="marketing-kpi" itemCount={1} />
          ) : (
            <CardContent>
              <div className="flex items-center justify-between pb-2">
              <p className="text-sm font-medium text-muted-foreground">
                Total Orders
              </p>
              <div className="h-4 w-4 text-muted-foreground"></div>
            </div>
            <div className="text-2xl font-bold">{totalOrders}</div>          
            {showTrend && (
              <p
                  className={`text-sm ${
                    Number(ordersGrowth) >= 0
                      ? "text-green-500"
                      : "text-red-600"
                  }`}
                >
                  {Number(ordersGrowth) > 0 ? "+" : ""}
                  {ordersGrowth}% from last month
                </p>
            )}
            </CardContent>
          )}
        </Card>
      </div>
    </>
  );
}
